import {
    SHOW_RIGHT_POPUP_PROPS,
    HIDE_RIGHT_POPUP_BOX
} from './actionConstants';

const initialState = {
    flag:false,
    title:null,
    component:null
};

export default function rightPopup(state=initialState, action){
    switch(action.type){
        case SHOW_RIGHT_POPUP_PROPS:
            return Object.assign (
                {},
                state,
                {
                    ...action.payload,
                    showCloseButton: true,
                }
            );

        case HIDE_RIGHT_POPUP_BOX :
            return initialState;

        default :
            return state;
    }
}